import { StepConfig } from '@/types';

/**
 * Paths & Prerequisites can differ between partners,
 * so each partner gets its own STEP config.
 */

export const STEP: Record<string, StepConfig> = {
  EMAIL: {
    path: '/email',
    prereqs: [],
  },
  ACCOUNT: {
    path: '/account',
    prereqs: ['email'],
  },
  DELIVERY: {
    path: '/delivery',
    prereqs: ['netsuiteOrderId'],
  },
  REVIEW: {
    path: '/review',
    prereqs: ['sku'],
  },
  SELECT: {
    path: '/select',
    prereqs: ['netsuiteOrderId'],
  },
  SIZING: {
    path: '/sizing',
    prereqs: ['netsuiteOrderId'],
  },
  SUMMARY: {
    path: '/summary',
    prereqs: [],
  },
  REVIEW_ENROLLMENT: {
    path: '/review-enrollment',
    prereqs: ['sizingKit'],
  },
};

/**
 * Metrics
 */

export const DELIVERY_METRIC_NAME = 'delivery';
export const SELECTIONS_METRIC_NAME = 'selections';
export enum MetricStep {
  DELIVERY_SUBMITTED = 'delivery_submitted',
  DELIVERY_SUCCESS = 'delivery_success',
  DELIVERY_ERROR = 'delivery_error',
  SELECTIONS_SUBMITTED = 'selections_submitted',
  SELECTIONS_SUCCESS = 'selections_success',
  SELECTIONS_ERROR = 'selections_error',
}
